import type { FC, ReactElement } from "react";
import { useState, useRef, useEffect } from "react";
import { PlainTooltip } from "@similarweb/ui-components";
import type { IStyledComponent } from "styled-components";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const { carbon } = colorsPalettes;

const ItemTag = styled.div<{ withPointer: boolean }>`
    max-width: 124px;
    border-radius: 20px;
    height: 25px;
    padding: 4px 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: ${carbon[25]};
    ${setFontVariant("chip1", carbon[400])};
    cursor: ${({ withPointer }) => (withPointer ? "pointer" : "default")};
`;

interface IEllipsisText {
    text: string;
    ItemTagContainer?: IStyledComponent<"web", any>;
    tooltipContent?: ReactElement;
    placement?: string;
}

export const EllipsisText: FC<IEllipsisText> = ({ text, ItemTagContainer = ItemTag, tooltipContent, placement }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const isTextOverflowing = textRef.current && textRef.current.scrollWidth > textRef.current.clientWidth;
        setIsOverflowing(isTextOverflowing);
    }, [text]);

    return isOverflowing ? (
        <PlainTooltip
            tooltipContent={tooltipContent ?? text}
            placement={placement ?? "top-center"}
        >
            <ItemTagContainer withPointer={true}>{text}</ItemTagContainer>
        </PlainTooltip>
    ) : (
        <ItemTagContainer
            ref={textRef}
            withPointer={false}
        >
            {text}
        </ItemTagContainer>
    );
};
